import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { bulkPackingSlipsPrint } from '../../../../store/orders/orders.actions';
import { printPackingSlip } from '../../../../store/printing/print.actions';
import { getIsBatchDetailsPage } from '../../../../store/batches/batches.helpers';
import { labelQuePrintPackingSlipStart } from '../../../../store/label-que/label-que.actions';
import Global from '../../../../store/global-selectors';

import { useFulfillmentPlanInformation } from './use-fulfillment-plan-information';
import { emptyObject } from 'ui-components/default-props/empty';

export const usePackingSlipDisabledCheck = ({ fulfillmentPlans, salesOrders }) => {
  const dispatch = useDispatch();
  const isOnBatchesGrid = getIsBatchDetailsPage();
  const isOnScanPage = useRouteMatch('/scan');
  const isOnAllowedPageForPrinting = isOnBatchesGrid || isOnScanPage;
  const isDisabled = !isOnAllowedPageForPrinting && salesOrders.length === 0;
  const { fulfillmentPlanIds, someFulfillmentPlansHavePrintedPackingSlip } = useFulfillmentPlanInformation(fulfillmentPlans);
  const { fulfillmentPlanSetId } = useSelector(Global.selectBatchDetailsBatch) || emptyObject;

  const onClick = useCallback(
    (openPrintDialog) => {
      if (isOnBatchesGrid && fulfillmentPlanIds.length === 0 && fulfillmentPlanSetId) {
        dispatch(labelQuePrintPackingSlipStart(fulfillmentPlanSetId, !openPrintDialog));
        return;
      }
      if (fulfillmentPlanIds.length === 1) {
        dispatch(printPackingSlip(fulfillmentPlanIds, someFulfillmentPlansHavePrintedPackingSlip, false, !openPrintDialog));
        return;
      }

      dispatch(bulkPackingSlipsPrint(!openPrintDialog));
    },
    [isOnBatchesGrid, fulfillmentPlanIds, dispatch, fulfillmentPlanSetId, someFulfillmentPlansHavePrintedPackingSlip],
  );

  return useMemo(
    () => ({
      isDisabled,
      onClick,
    }),
    [isDisabled, onClick],
  );
};
